<template>
  <div class="order">
    <!-- Add your template content here -->
    <div class="order-details">
      <div class="order-header">
        <img class="order-img" :src="getOrderImage" />
        <span class="order-title">{{ payStatusText }}</span>

        <div
          v-if="orderStatus == 2 || orderStatus == 3"
          class="top_remark"
          @click="goDetail()"
        >
          <span class="text-top-left">退款金额</span>
          <div class="top_right">
            <span v-if="orderStatus == 2" class="text-top_text"
              >￥{{ orderRefundAmount }}资金将原路退回</span
            >
            <span v-if="orderStatus == 3" class="text-top_text"
              >￥{{ orderRefundAmount }}</span
            >
            <img class="right-img" src="@/assets/arrow_right.png" />
          </div>
        </div>

        <span
          v-if="orderStatus == 4 || orderStatus == 5"
          class="top-remark-text"
          >请联系客服处理！</span
        >
      </div>

      <div class="line20"></div>

      <div class="order-bottom">
        <div class="order-bottom-item">
          <div class="text-bottom">详情</div>
        </div>

        <div class="order-content">
          <div class="product-name">
            <img class="product-img" :src="this.picUrl" />
            <div class="product-info">
              <span class="product-info-text">{{
                orderType === "D" ? modelName : name
              }}</span>
              <span class="product-info-text2">{{
                orderType === "D" ? sn : packageDesc
              }}</span>
            </div>
          </div>

          <div class="price-section">
            <span class="price-label"
              >¥{{ orderType === "D" ? amount : price }}</span
            >
            <span class="price-value">x{{ count }}</span>
          </div>
        </div>

        <div class="line"></div>

        <div class="order-detail-item">
          <span class="text-detail-left">总金额</span>
          <span class="text-detail-right">¥{{ amount }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">平台优惠金额</span>
          <span class="text-detail-right">¥{{ platformDiscount }}</span>
        </div>

        <div class="order-detail-item" v-if="upgradeOldAmount > 0">
          <span class="text-detail-left">套餐升级优惠</span>
          <span class="text-detail-right">¥{{ upgradeOldAmount }}</span>
        </div>

        <div class="order-detail-item">
          <span class="text-detail-left">优惠券金额</span>
          <span class="text-detail-right">¥{{ couponDiscount }}</span>
        </div>

        <div class="order-detail-item">
          <span class="text-detail-left">实付金额</span>
          <span class="text-detail-right">¥{{ realAmount }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">订单流水号</span>
          <span class="text-detail-right">{{ payOrderNo }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">支付方式</span>
          <span class="text-detail-right">{{ payModeText }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">支付订单号</span>
          <span class="text-detail-right">{{ channelOrderNo }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">支付时间</span>
          <span class="text-detail-right">{{ payTime }}</span>
        </div>
        <div v-if="orderType === 'T'" class="order-detail-item">
          <span class="text-detail-left">设备编号</span>
          <span class="text-detail-right">{{ sn }}</span>
        </div>
        <div v-if="orderType === 'D'" class="order-detail-item">
          <span class="text-detail-left"></span>
          <span class="text-detail-yajin" @click="Agreement">《押金说明》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderListDetail } from "@/api/user";
import { getAgreement } from "@/api/home";
import { Toast } from "vant";
export default {
  name: "OrderDetails",
  data() {
    return {
      // Add your component data here
      id: "", //订单号
      orderStatus: "", //支付状态 1-已完成，2-退款处理中，3-退款成功，4-退款异常，5-退款失败
      picUrl: "", //图片地址
      orderRefundAmount: "", //退款金额
      refundOrderNo: "", //退款单号
      orderType: "", //订单类型
      modelName: "",
      sn: "",

      name: "", //商品名称
      packageDesc: "", //商品描述
      price: "", //商品价格

      count: "", //数量
      amount: "", //总金额
      // discountAmount: "", //优惠金额
      realAmount: "", //实付金额
      // orderNo: "", //
      payMode: "", //支付方式
      payOrderNo: "", //订单流水号
      channelOrderNo: "", //支付订单号
      payTime: "", //支付时间

      platformDiscount:"",//平台优惠金额(元)
      upgradeOldAmount:"",//套餐升级优惠(元)
      couponDiscount:"",//优惠券金额(元)
    };
  },

  computed: {
    getOrderImage() {
      // 定义状态与图片的映射关系
      const statusImages = {
        1: require("@/assets/order_img.png"), // 已完成
        2: require("@/assets/order_tking_img.png"), // 退款处理中
        3: require("@/assets/order_img.png"), // 退款成功
        4: require("@/assets/order_tkyc_img.png"), // 退款异常
        5: require("@/assets/order_tksb_img.png"), // 退款失败
      };
      // 返回匹配的图片，若无匹配则用默认图
      return statusImages[this.orderStatus];
    },
    payStatusText() {
      return this.orderStatus === 1
        ? "交易成功"
        : this.orderStatus === 2
        ? "退款处理中"
        : this.orderStatus === 3
        ? "退款成功"
        : this.orderStatus === 4
        ? "退款异常"
        : this.orderStatus === 5
        ? "退款失败"
        : "-";
    },
    payModeText() {
      return this.payMode === "Wechat"
        ? "微信支付"
        : this.payMode === "Alipay"
        ? "支付宝支付"
        : "-";
    },
  },
  methods: {
    // Add your component methods here
    getOrderDetail() {
      getOrderListDetail({ id: this.$route.query.id })
        .then((res) => {
          console.log("获取详情成功：" + res);
          this.orderStatus = res.orderStatus;
          this.orderRefundAmount = res.orderRefundAmount;
          this.refundOrderNo = res.refundOrderNo;
          this.picUrl = res.picUrl;

          this.count = res.count;
          this.amount = res.amount;
          // this.discountAmount = res.discountAmount;
          this.realAmount = res.realAmount;
          this.channelOrderNo = res.channelOrderNo;
          this.payMode = res.payMode;
          this.payOrderNo = res.payOrderNo;
          this.payTime = res.payTime;
          this.orderType = res.orderType;
          this.modelName = res.modelName ? res.modelName : "";
          this.sn = res.sn ? res.sn : "";
          this.name = res.trafficPackageInfo.name
            ? res.trafficPackageInfo.name
            : "";
          this.packageDesc = res.trafficPackageInfo.packageDesc
            ? res.trafficPackageInfo.packageDesc
            : "";
          this.price = res.trafficPackageInfo.price
            ? res.trafficPackageInfo.price
            : "";


            this.platformDiscount = res.platformDiscount;//平台优惠金额(元)
            this.upgradeOldAmount = res.upgradeOldAmount;//套餐升级优惠(元)
            this.couponDiscount = res.couponDiscount;//优惠券金额(元)

        })
        .catch((err) => {
          console.error("获取详情失败：" + err);
        });
    },
    //跳转到退款详情页
    goDetail() {
      this.uni.navigateTo(
        "/user/orderrefund?refundOrderNo=" + this.refundOrderNo
      );
    },
    Agreement() {
      getAgreement({
        appType: "U",
        protocolTypes: [4],
      }).then((res) => {
        this.goToAgreement(res);
      });
    },
    goToAgreement(res) {
      this.agreementList = res.map((item) => {
        return {
          name: item.name,
          url: item.url,
        };
      });
      if (this.agreementList[0] && this.agreementList[0].url) {
        window.location.href = this.agreementList[0].url;
      } else {
        Toast.fail("协议链接无效");
      }
    },
  },

  mounted() {
    // Add your mounted logic here
    this.getOrderDetail();
  },
};
</script>

<style lang="less" scoped>
.order {
  /* Add your styles here */
  height: 100%;
  background: white;
  .order-details {
    flex-direction: column;
    display: flex;
    .order-header {
      background: white;
      height: 326px;
      align-items: center;
      display: flex;
      flex-direction: column;
      .order-title {
        font-size: 36px;
        color: #000000;
        margin-top: 20px;
        font-weight: bold;
      }
      .order-img {
        width: 96px;
        height: 96px;
        margin-top: 80px;
      }
      .top-remark-text {
        font-size: 28px;
        color: var(--primary-color);
        margin-top: 20px;
      }
      .top_remark {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-top: 20px;
        .text-top-left {
          font-size: 26px;
          color: #848992;
          margin-left: 32px;
        }
        .top_right {
          display: flex;
          flex-direction: row;
          margin-right: 32px;
          .text-top_text {
            font-weight: bold;
            font-size: 28px;
            color: var(--primary-color);
            text-align: right;
          }
          .right-img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
  .line20 {
    height: 20px;
    background: #f2f2f2;
  }
  .order-bottom {
    background: white;
    display: flex;
    flex: 1;
    flex-direction: column;
    .order-bottom-item {
      display: flex;
      align-items: center;
      padding-left: 30px;
      padding-right: 40px;
      height: 100px;
      .order-img-line {
        width: 6px;
        height: 24px;
      }
      .text-bottom {
        font-size: 32px;
        color: #000000;
        padding-left: 24px;
        font-weight: bold;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 24px;
          background: var(--primary-color);
          border-radius: 12px;
        }
      }
    }
    .order-content {
      display: flex;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 20px;
      .product-name {
        display: flex;
        flex-direction: row;
        margin-right: 30px;
        .product-img {
          width: 132px;
          height: 132px;
        }
        .product-info {
          margin-left: 16px;
          display: flex;
          flex-direction: column;
          .product-info-text {
            font-size: 30px;
            color: #000000;
          }
          .product-info-text2 {
            font-size: 26px;
            color: #848992;
            margin-top: 8px;
          }
        }
      }
      .price-section {
        display: flex;
        flex-direction: column;
        text-align: right;
        .price-label {
          font-size: 30px;
          color: #000000;
        }
        .price-value {
          font-size: 26px;
          color: #848992;
          margin-top: 12px;
          align-items: right;
        }
      }
    }
    .line {
      height: 1px;
      background: #f1f1f1;
      margin-top: 32px;
      margin-left: 30px;
      margin-right: 30px;
    }
    .order-detail-item {
      display: flex;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 20px;
      .text-detail-left {
        font-size: 26px;
        color: #848992;
      }
      .text-detail-right {
        font-size: 26px;
        color: #000000;
      }
      .text-detail-yajin {
        font-size: 26px;
        color: #fd8d32;
      }
    }
  }
}
</style>
